{
  "FormerRebel": "Former Rebel",

  "PolicyLink": "To learn more, view our privacy policy.",

  "NoMatchTitle": "404 page",
  "LittleLostPhrase": "Oh shoot. Seems like you are a little lost",
  "Go": "Go",
  "back": "back",
  "or": "or",
  "homeToYour": "home to your",
  "profile": "profile",
  "home": "home",
  "Explore": "Explore,",
  "theySay": "they say...",
  "ItWillBeFun": "It will be fun,",

  "NoPermissionTitle": "Woop Woop.",
  "NoPermissionPhrase": "You are not permitted to view this page.",

  "rebellionStarted": "The rebellion has started.",
  "RebelsBreakRules": "Rebels break rules that are meant to be broken.",
  "LookingForLostEntrepreneurs": "We are looking for lost entrepreneurs. Have you seen which way they went?",
  "inner-innovator": "Your inner-innovator is showing.",
  "PopcornAnyone": "If dreams are corn kernels, RebelBase makes them pop. Popcorn, anyone?",
  "GotAnIdea": "Got an idea you tossed in your junk drawer you thought could wait for later? Later is here."
}
